// DEV
// export const baseURL_ru = 'http://172.16.33.102:8081/api/'
// export const baseURL_ru = 'http://195.91.152.252:8080/api/'
// export const serverUrl_ru = ''
// export const serverUrl_ru = 'http://172.16.33.102:8081'
// export const serverUrl_ru = 'http://195.91.152.252:8080'
// export const sentryDsn =
//   'https://4498a0cfe8354d2fb78708b4fc180698@sentry.io/1319545'

// PROD
export const baseURL_ru = 'https://sd1.hrsinternational.com/api'
export const baseURL_en = 'https://sd.hrsinternational.com/api'
// export const baseURL_ru = 'http://poweredbyme.ru:8081/api'
// export const baseURL_ru = 'https://928d-212-119-243-237.ngrok.io/api'

export const serverUrl_ru = 'https://sd1.hrsinternational.com'
export const serverUrl_en = 'https://sd.hrsinternational.com'

export const domain_ru = 'helpdesk.hrs.ru'
export const domain_en = 'helpdesk.hrsinternational.com'
// export const serverUrl_ru = 'http://poweredbyme.ru:8081'
// export const serverUrl_ru = 'https://928d-212-119-243-237.ngrok.io'
export const sentryDsn =
  'https://4ac7d4ad5d1f42e8a02a52028bc957f2@sentry.io/1399473'

export const JIVO_TOKEN = 'zcaR7c8HnN'
